import { render, staticRenderFns } from "./monomerDetails.vue?vue&type=template&id=3ae32dcf"
import script from "./monomerDetails.vue?vue&type=script&lang=js"
export * from "./monomerDetails.vue?vue&type=script&lang=js"
import style0 from "./monomerDetails.vue?vue&type=style&index=0&id=3ae32dcf&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports